// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ca4089a6","389":"2506329f","453":"d668cb3f","455":"7a8f13cf","977":"9cdd1ab0"}[chunkId] + ".chunk.js";
};